import { apiClient } from "./client";
import { repairAndParseJSON } from "../utils/jsonRepair";
import { API_ENDPOINTS } from "./endpoints";

export const addToCart = async (cartData) => {
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";
    const mobno = localStorage.getItem("mobno") || loginname;

    try {
        const response = await apiClient.post(API_ENDPOINTS.CART.ADD, cartData, {
            params: {
                mobno: mobno
            },
            headers: {
                token: token,
                loginname: loginname
            }
        });

        if (response.data) {
            return repairAndParseJSON(response.data);
        }
        return { Status: 0, message: "No data received" };
    } catch (error) {
        console.error("Cart Add API failed", error);
        throw error;
    }
};

export const getCartDetails = async () => {
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";
    const mobno = localStorage.getItem("mobno") || loginname;

    try {
        const response = await apiClient.get(API_ENDPOINTS.CART.DETAIL, {
            params: { mobno },
            headers: { token, loginname }
        });

        if (response.data) {
            const data = repairAndParseJSON(response.data);
            return data?.Data || data?.data || [];
        }
        return [];
    } catch (error) {
        console.error("Cart Detail API failed", error);
        throw error;
    }
};

export const getCartSummary = async () => {
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";
    const mobno = localStorage.getItem("mobno") || loginname;

    try {
        const response = await apiClient.get(API_ENDPOINTS.CART.SUMMARY, {
            params: { mobno },
            headers: { token, loginname }
        });

        if (response.data) {
            const data = repairAndParseJSON(response.data);
            return data?.Data?.[0] || data?.data?.[0] || null;
        }
        return null;
    } catch (error) {
        console.error("Cart Summary API failed", error);
        throw error;
    }
};
export const updateCart = async (cartData) => {
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";
    const mobno = localStorage.getItem("mobno") || loginname;

    try {
        const response = await apiClient.post(API_ENDPOINTS.CART.EDIT, cartData, {
            params: { mobno },
            headers: { token, loginname }
        });

        if (response.data) {
            return repairAndParseJSON(response.data);
        }
        return { Status: 0, message: "No data received" };
    } catch (error) {
        console.error("Cart Edit API failed", error);
        throw error;
    }
};

export const deleteFromCart = async (billno) => {
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";
    const mobno = localStorage.getItem("mobno") || loginname;

    try {
        const response = await apiClient.post(API_ENDPOINTS.CART.DELETE, { billno }, {
            params: { mobno },
            headers: { token, loginname }
        });

        if (response.data) {
            return repairAndParseJSON(response.data);
        }
        return { Status: 0, message: "No data received" };
    } catch (error) {
        console.error("Cart Delete API failed", error);
        throw error;
    }
};

export const checkout = async () => {
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";
    const mobno = localStorage.getItem("mobno") || loginname;

    try {
        const response = await apiClient.get(API_ENDPOINTS.CART.CHECKOUT, {
            params: { mobno },
            headers: { 
                token: token,
                loginname: loginname
            }
        });

        if (response.data) {
            return repairAndParseJSON(response.data);
        }
        return { Status: 0, message: "No data received" };
    } catch (error) {
        console.error("Checkout API failed", error);
        throw error;
    }
};
